import React from 'react';
import { Grid, Typography } from '@mui/material';

import ProtectedServiceField from './ProtectedServiceField';
import ServiceApiKeyField from './ServiceApiKeyField';
import ServiceModelField from './ServiceModelField';

export default function GuardrailServiceConfig({
  title,
  value = {},
  onChange,
  disabled = false,
  required = false,
  error = false,
  service_label = 'Service',
  label_id = 'guardrail-service-label',
  show_api_key = true,
}) {
  const handleIdChange = (id) => {
    onChange({ ...value, id });
  };

  const handleApiKeyChange = (api_key) => {
    onChange({ ...value, api_key });
  };

  const handleModelChange = (model) => {
    onChange({ ...value, model });
  };

  return (
    <Grid container spacing={2}>
      {title ? (
        <Grid size={12}>
          <Typography variant='body2' fontWeight='medium'>
            {title}
          </Typography>
        </Grid>
      ) : null}
      <Grid size={12}>
        <ProtectedServiceField
          value={value.id || ''}
          onChange={handleIdChange}
          disabled={disabled}
          required={required}
          error={error}
          label={service_label}
          label_id={label_id}
        />
      </Grid>
      {show_api_key ? (
        <Grid size={{ xs: 12, md: 6 }}>
          <ServiceApiKeyField
            value={value.api_key || ''}
            onChange={handleApiKeyChange}
            disabled={disabled}
          />
        </Grid>
      ) : null}
      <Grid size={{ xs: 12, md: show_api_key ? 6 : 12 }}>
        <ServiceModelField
          value={value.model || ''}
          onChange={handleModelChange}
          disabled={disabled}
        />
      </Grid>
    </Grid>
  );
}
